var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { defaultProps } from './defaults';
import { DivTag, SpanTag } from '../../Utils/AtomicTag';
import { isEqual, date2Str, compareDate, parseDate2Str } from './utils';
import { getCalendarDateItem } from '@feb-team/data-logic';
var DateDayPicker = /** @class */ (function (_super) {
    __extends(DateDayPicker, _super);
    function DateDayPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.weeks = ['日', '一', '二', '三', '四', '五', '六'];
        _this.componentWillReceiveProps = function (nextProps) {
            _this.setState(_this.initData(nextProps));
        };
        /**
         * 初始化数据
         * @param props
         */
        _this.initData = function (props) {
            var year = props.year, month = props.month, day = props.day, nextYear = props.nextYear, nextMonth = props.nextMonth, rangeDate = props.rangeDate, range = props.range;
            return {
                year: year,
                month: month,
                day: day,
                nextYear: nextYear,
                nextMonth: nextMonth,
                rangeDate: rangeDate,
                hoverDate: '',
            };
        };
        /**
         * 选中日期
         * @param year
         * @param month
         * @param day
         * @param idx
         */
        _this.choose = function (e, year, month, day) {
            _this.props.chooseDay(e, parseDate2Str(year, month, day));
        };
        /**
         * 划入可选区域
         * @param e
         * @param year
         * @param month
         * @param day
         */
        _this.mouseEnter = function (e, year, month, day) {
            _this.setState({
                hoverDate: parseDate2Str(year, month, day),
            });
        };
        /**
         * 划出可选区域
         * @param e
         */
        _this.mouseLeave = function (e) {
            _this.setState({
                hoverDate: '',
            });
        };
        /**
         * 渲染月份日期
         */
        _this.renderBody = function () {
            var boxCls = ['inline-flex'];
            var wrapCls = [
                'h-px-250',
                'w-px-240',
                'py-px-8',
                'px-px-8',
                'border',
                'border-l-0',
                'border-b-0',
                'border-r-0',
                'border-solid',
                'border-gray-200',
                'text-center',
            ];
            var weeksCls = [
                'h-px-32',
                'mb-px-8',
                'flex',
                'items-center',
                'justify-center',
            ];
            var weekCls = ['flex-1'];
            var daysCls = ['h-px-32', 'flex', 'flex-wrap'];
            var dayCls = [
                'w-px-32',
                'h-px-32',
                'flex',
                'items-center',
                'justify-center',
                'cursor-pointer',
            ];
            var dayActiveCls = ['text-white', 'bg-brand-600'];
            var dayRangeCls = ['text-white', 'bg-brand-100', 'rounded-none'];
            var dayHoverCls = ['text-black', 'bg-gray-200', 'hover:text-black'];
            var dayDisableCls = ['text-gray-400', 'cursor-not-allowed'];
            var _a = _this.props, double = _a.double, value = _a.value, rangeIdx = _a.rangeIdx, disabledItems = _a.disabledItems, range = _a.range;
            var _b = _this.state, year = _b.year, month = _b.month, nextYear = _b.nextYear, nextMonth = _b.nextMonth, rangeDate = _b.rangeDate, hoverDate = _b.hoverDate;
            var daysList = [
                {
                    dateItems: getCalendarDateItem(new Date(year + "/" + month + "/01"), 0, 42),
                    month: month,
                },
            ];
            if (double) {
                daysList.push({
                    dateItems: getCalendarDateItem(new Date(nextYear + "/" + nextMonth + "/01"), 0, 42),
                    month: nextMonth,
                });
            }
            return (React.createElement(DivTag, { name: DateDayPicker.NAME, atomics: boxCls }, daysList.length &&
                daysList.map(function (days, idx) {
                    return (React.createElement(DivTag, { atomics: wrapCls, key: idx },
                        React.createElement(DivTag, { atomics: weeksCls }, _this.weeks.map(function (item) {
                            return (React.createElement(SpanTag, { atomics: weekCls, key: item }, item));
                        })),
                        React.createElement(DivTag, { atomics: daysCls }, days.dateItems.map(function (item) {
                            var currDate = parseDate2Str(item.year, item.month, item.date);
                            var isUnCurrMonth = days.month != item.month ||
                                !((range[0] ? !compareDate(currDate, range[0]) : true) &&
                                    (range[1] ? !compareDate(range[1], currDate) : true));
                            var isDisabledItem = disabledItems.includes(currDate);
                            var isDisabled = !rangeIdx || !rangeDate
                                ? false
                                : (rangeIdx === 2 && compareDate(currDate, rangeDate)) ||
                                    (rangeIdx === 1 && compareDate(rangeDate, currDate));
                            // !非本月日期（显示置灰的上个月下个月） && !传入的不可点击日期 && !区间不可点击区域
                            var isHasInteraction = !isUnCurrMonth && !isDisabledItem && !isDisabled;
                            // 选中日期
                            var isChooseDay = !isUnCurrMonth &&
                                !isDisabled &&
                                ((value && isEqual(value, currDate)) || isEqual(rangeDate, currDate));
                            // 今天
                            var isDays = !isUnCurrMonth && isEqual(currDate, date2Str(new Date(), '-'));
                            var isHoverDay = isEqual(currDate, hoverDate) && !isDisabledItem && !isUnCurrMonth;
                            var isRangeDay = isHasInteraction && rangeIdx && value && rangeDate
                                ? (rangeIdx === 2 &&
                                    compareDate(rangeDate, currDate) &&
                                    compareDate(currDate, value)) ||
                                    (rangeIdx === 1 &&
                                        compareDate(value, currDate) &&
                                        compareDate(currDate, rangeDate))
                                : false;
                            var isHoverRangeDay = isHasInteraction &&
                                rangeIdx &&
                                rangeDate &&
                                hoverDate &&
                                ((rangeIdx === 2 &&
                                    compareDate(rangeDate, currDate) &&
                                    compareDate(currDate, hoverDate)) ||
                                    (rangeIdx === 1 &&
                                        compareDate(hoverDate, currDate) &&
                                        compareDate(currDate, rangeDate)));
                            return (React.createElement(SpanTag, { atomics: dayCls.concat(isChooseDay ? dayActiveCls : [], isRangeDay ? dayRangeCls : [], isHoverRangeDay && !isDisabled ? dayRangeCls : [], isHoverDay && !isDisabled ? dayHoverCls : [], isDisabled || isDisabledItem || isUnCurrMonth ? dayDisableCls : []), className: isDays ? 'date-picker-days' : '', key: item.month + "-" + item.date, onClick: function (e) {
                                    return isHasInteraction && _this.choose(e, item.year, item.month, item.date);
                                }, onMouseEnter: function (e) {
                                    return isHasInteraction && _this.mouseEnter(e, item.year, item.month, item.date);
                                }, onMouseLeave: function (e) { return isHasInteraction && _this.mouseLeave(e); } }, item.date));
                        }))));
                })));
        };
        _this.state = _this.initData(props);
        return _this;
    }
    DateDayPicker.prototype.render = function () {
        return React.createElement(React.Fragment, null, this.renderBody());
    };
    DateDayPicker.defaultProps = defaultProps;
    DateDayPicker.NAME = 'date-day-picker';
    return DateDayPicker;
}(Component));
export { DateDayPicker };
